import Link from 'next/link';
import React from 'react';

import {
    CertificationAggregatorApi,
    CertificationTopic,
    PaginatedContent,
    CertificationTopicCarousel as CertificationTopicCarouselComponent,
} from '@udemy/browse-aggregator';
import {ClickEvent, Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {Icon} from '@udemy/icons';
import {Button} from '@udemy/react-core-components';

import {udemyApi} from 'src/lib/ud-global-fetch';

import {CARD_CAROUSEL_PAGE_SIZE, MAX_CARDS_ON_STACKED_VIEW} from '../../utils/constants';
import styles from './certification-preparation.module.less';

export const CertificationTopicCarousel = (props: {
    initialData: PaginatedContent<CertificationTopic> | null;
}) => {
    const {initialData} = props;
    const {gettext} = useI18n();

    if (!initialData) {
        return null;
    }
    const certificationAggregatorApi = new CertificationAggregatorApi(udemyApi);

    const title = gettext('Most in demand certifications');
    const url = '/browse/certification';

    const FETCH_BY = 'by_descriptor_type';
    const FETCH_BY_VALUE = 'all';

    const trackAllCertificationsClick = () => {
        Tracker.publishEvent(
            new ClickEvent({
                componentName: 'seeAllCertificationsButton',
            }),
        );
    };

    return (
        <div className={styles['certification-topic-carousel-wrapper']}>
            <CertificationTopicCarouselComponent
                key={`black-friday-cyber-monday-sales-top-certification-topic-carousel`}
                title={title}
                fetchBy={FETCH_BY}
                fetchByValue={FETCH_BY_VALUE}
                certificationAggregatorApi={certificationAggregatorApi}
                useStackedCards={true}
                stackedCardsProps={{
                    maxCards: MAX_CARDS_ON_STACKED_VIEW,
                }}
                initialData={initialData}
                pageSize={CARD_CAROUSEL_PAGE_SIZE}
                aggregatorCardProps={{
                    linkComponent: (props: {href: string; children?: React.ReactNode}) => (
                        <Link {...props} legacyBehavior={false}>
                            {props.children}
                        </Link>
                    ),
                }}
            />
            <Button
                componentClass="a"
                udStyle="ghost"
                href={url}
                target="_self"
                size="medium"
                className={styles['view-all-certifications-link']}
                onClick={trackAllCertificationsClick}
            >
                {gettext('All Certification Preparation')}

                <Icon label={false} glyph="arrow-right" className="ud-icon-bi-directional" />
            </Button>
        </div>
    );
};
